import React from 'react';
import { Header } from '../components/Header';
import { LiveVisitorsBanner } from '../components/LiveVisitorsBanner';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  // Initialize Meta Pixel on mount
  useMetaPixel();
  return <div className="min-h-screen bg-brand-bg font-body text-brand-text selection:bg-brand-primary/30" data-id="element-194">
      <Header data-id="element-195" />
      <LiveVisitorsBanner data-id="element-196" />

      <main data-id="element-197">
        <HeroSection data-id="element-198" />
        <ProblemSection data-id="element-199" />
        <MethodSection data-id="element-200" />
        <OfferSection data-id="element-201" />
        <HowItWorksSection data-id="element-202" />
        <ReviewsSection data-id="element-203" />
        <FAQSection data-id="element-204" />
        <GuaranteeSection data-id="element-205" />
        <PricingSection data-id="element-206" />
      </main>

      <Footer data-id="element-207" />
      <PurchasePopup data-id="element-208" />
    </div>;
}